export type NipperLogKind = "sent" | "firmware" | "note";

export interface NipperLogLine {
  at: string;
  kind: NipperLogKind;
  text: string;
}

/** `→` is a command we wrote; `←` is a frame the firmware returned. */
export function toNipperLogLine(message: string, at = new Date().toLocaleTimeString()): NipperLogLine {
  if (message.startsWith("→ ")) return { at, kind: "sent", text: message.slice(2) };
  if (message.startsWith("← ")) return { at, kind: "firmware", text: message.slice(2) };
  return { at, kind: "note", text: message };
}

export function formatNipperLog(lines: NipperLogLine[]): string {
  return lines.map((line) => `${line.at}\t${line.kind}\t${line.text}`).join("\n");
}
